<div class="consent-forms-dialog" dir="rtl">

  <div class="consent-forms-header">
    <h2 class="t-title-main">טפסי הסכמה</h2>
    <button class="close-btn" (click)="close()" matTooltip="סגור">
      <span class="close-x" aria-hidden="true">✕</span>
    </button>
  </div>
<div class="new-consent-section">
    <label class="field-block">
      <span class="field-label">סוג טופס חדש</span>
      <select class="t-select" [(ngModel)]="newConsentType">
        <option value="" disabled>בחר סוג</option>
        <option *ngFor="let type of consentTypes" [value]="type.key">{{ type.label }}</option>
      </select>
    </label>
    <label
      class="field-block"
      *ngIf="ls.userType !== 'doctor' && !ls.ishospital && clinicPractitioners?.length > 1"
    >
      <span class="field-label">רופא</span>
      <select class="t-select" [(ngModel)]="practitionerObj">
        <option [ngValue]="null"></option>
        <option *ngFor="let p of clinicPractitioners" [ngValue]="p">{{ p.Title }} {{ p.Name }}</option>
      </select>
    </label>
    <span class="new-consent-spacer"></span>
    <button class="blue-btn" [disabled]="!canStartNew()" (click)="startNew()">צור טופס חדש</button>
  </div>
  <div *ngIf="loading" class="loading-msg">טוען...</div>

  <div *ngIf="!loading" class="consents-list">
    <div class="consent-row consent-row-head">
      <span class="col-date">תאריך</span>
      <span class="col-type">סוג</span>
      <span class="col-status">סטטוס</span>
      <span class="col-actions"></span>
    </div>
    <div class="consent-row" *ngFor="let c of consents">
      <span class="col-date">{{ c.CreationTime | date:'dd.MM.yyyy HH:mm' }}</span>
      <span class="col-type">{{ typeLabel(c.ConsentType) }}</span>
      <span class="col-status" [class.signed]="isSigned(c)">{{ statusLabel(c) }}</span>
      <span class="col-actions">
        <button class="blue-btn" (click)="openExisting(c)">פתח</button>
        <button class="orange-btn" (click)="printConsent(c)" matTooltip="הדפס">הדפס</button>
      </span>
    </div>
    <div class="consent-row consent-row-empty" *ngIf="!consents.length">
      אין טפסי הסכמה לתאריך זה
    </div>
  </div>

  
  <div class="close-row">
    <button class="orange-btn" (click)="close()">סגור</button>
  </div>
</div>
